import type { BusinessUnitSelectVariables } from '@/common/components/shared/select/business-unit/BusinessUnitSelect';
import type { CompanySelectVariables } from '@/common/components/shared/select/company/CompanySelect';
import type { DepartmentSelectVariables } from '@/common/components/shared/select/department/DepartmentSelect';
import type { JobSelectVariables } from '@/common/components/shared/select/job/JobSelect';
import type { ListEmployeesSortInput } from '@/common/graphql';

export interface EmployeeSearchProps {
  /** Sort order applied to the employee search results, in priority order. */
  sort?: Array<ListEmployeesSortInput>;
  /** Auto-selects the Company filter to this id or ids. See `EmployeeSearchForm`'s `defaultCompanyId`. */
  defaultCompanyId?: string | string[];
  /** Auto-selects the Country filter to this id or ids. See `EmployeeSearchForm`'s `defaultCountryId`. */
  defaultCountryId?: string | string[];
  /**
   * Auto-selects the Department filter to this exact name or names once Departments finish loading;
   * no-op for any name with no match. See `EmployeeSearchForm`'s `defaultDepartmentName` for the full contract.
   */
  defaultDepartmentName?: string | string[];
  /** Per-sub-select query variable overrides for the form's Company/Business Unit/Department/Job filters. */
  searchFilters?: {
    company?: CompanySelectVariables;
    businessUnit?: BusinessUnitSelectVariables;
    department?: DepartmentSelectVariables;
    job?: JobSelectVariables;
  };
}
